module.exports = __webpack_public_path__ + "img/silver2.f3f9aa3a.png";